import { Resource as t, API as a } from "@coveo/platform-client";
const r = class r extends t {
  preview(e) {
    return this.api.post(r.baseUrl, e);
  }
};
r.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/v2/recommendations/preview`;
let s = r;
export {
  s as RecommendationSlotPreview
};
//# sourceMappingURL=RecommendationSlotPreview.js.map
